import { AppResource } from 'src/app/app.resource';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { BreadcrumbComponent } from 'src/app/shared/components/breadcrumb/breadcrumb.component';
import { FooterComponent } from 'src/app/shared/components/footer/footer.component';
import { HeaderComponent } from 'src/app/shared/components/header/header.component';
import { RouterModule } from '@angular/router';
import { WebCallbackComponent } from 'src/app/shared/components/web-callback/web-callback.component';
import { ResumeStepComponent } from 'src/app/shared/components/resume-step/resume-step.component';
import { BaseComponent } from 'src/app/shared/components/base/base.component';

@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  imports: [
    CommonModule,
    BreadcrumbComponent,
    FooterComponent,
    HeaderComponent,
    WebCallbackComponent,
    RouterModule,
    ResumeStepComponent
  ],
  standalone: true
})
export class AppLayoutComponent extends BaseComponent implements OnInit {
  demo: boolean = false;

  constructor(resources: AppResource) {
    super(resources);
  }

  override ngOnInit() {}
}
